import React from 'react'
import Box from '@mui/material/Box'
import HMapDetailsContent from './HMapDetailsContent'
import HMapDetailsFooter from './HMapDetailsFooter'

const HMapDetailsPanel = ({ setCurrentPanel, operation }) => {
  return (
    <Box
      sx={{
        alignItems: 'flex-start',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '100%'
      }}
    >
      <HMapDetailsContent />
      <HMapDetailsFooter setCurrentPanel={setCurrentPanel} />
    </Box>
  )
}

export default React.memo(HMapDetailsPanel)
